import type { Routes } from '@angular/router';

import { menuV2FeatureGuard } from '#modules/menu-v2/guards/menu-v2-feature.guard';

export const AGGREGATED_SEO_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/groups/aggregated-seo-layout/aggregated-seo-layout.component').then(
                (m) => m.AggregatedSeoLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'store-locator',
            },
            {
                path: 'store-locator',
                loadChildren: () => import('#modules/store-locator/routes/store-locator.routes').then((m) => m.STORE_LOCATOR_ROUTES),
            },
            {
                path: 'menu',
                canMatch: [menuV2FeatureGuard],
                loadChildren: () => import('#modules/menu-v2/routes/menu-v2.routes').then((m) => m.AGGREGATED_MENU_V2_ROUTES),
            },
            {
                path: 'menu',
                loadChildren: () => import('#modules/menu/routes/menu.routes').then((m) => m.AGGREGATED_MENU_ROUTES),
            },
        ],
    },
];
